export default {
  ownerGroup: 'Owner Group',
  warehouseCity: '城市',
  shipto: 'Shipto',
  defaultShipto: '默认 Shipto',
  siteType: 'Site 类型',
  createTime: '创建时间',
  updateTime: '更新时间'
}
